import { createElement as rc } from 'react';
import PropTypes from 'prop-types';
import HNode from '../../HNode';
import useHiddenForValue from '../../hooks/useHiddenForValue';

export default function HiddenForValue({
    hNode: {
        value,
        children: [hNode]
    },
    ...props
}) {
    if (useHiddenForValue(hNode, value)) return null;
    return rc(HNode, { ...props, hNode });
}

HiddenForValue.propTypes = {
    hNode: PropTypes.object
};
